import {ITriviaContests} from 'modules/types';

import {createAction} from 'redux-act';


/**
 * Actions to fetch contests
 * UAT example
 * https://uat-bww-play.fanhubmedia.com/trivia/json/contests.json
 */
export const fetchContests = createAction();
export const fetchContestsSuccess = createAction<ITriviaContests>();
export const fetchContestsFailed = createAction();
